import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { ToolsSection } from './components/ToolsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1651357612587495';
type MetaPixel = {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & MetaPixel;
    _fbq?: MetaPixel;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
        } as ((...args: unknown[]) => void) & MetaPixel;
        pixel.queue = [];
        pixel.push = (...args: unknown[]) => pixel.queue.push(args);
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        if (!window._fbq) window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-cream text-ink selection:bg-gold/25 selection:text-navy-deep" data-id="element-0" data-mp="3uevrdy3yu62k">
      <main data-id="element-1" data-mp="d2l6qzzotwz9">
        <Hero data-id="element-2" data-mp="85l30vqb96bb" />
        <TestimonialsStrip data-id="element-3" data-mp="851kbcsu6dw8" />
        <PainPoints data-id="element-4" data-mp="86w6svjrae2f" />
        <SolutionReveal data-id="element-5" data-mp="86cmj86mvdl8" />
        <TomosSection data-id="element-6" data-mp="3gle7udba4tcj" />
        <ToolsSection data-id="element-7" data-mp="3gkv2dw2tfxfe" />
        <BonusSection data-id="element-8" data-mp="3gm64lrgm4x4e" />
        <PricingSection data-id="element-9" data-mp="3glny8208l2ir" />
        <ExtendedTestimonials data-id="element-10" data-mp="3bmbehq4nwbke" />
        <Guarantee data-id="element-11" data-mp="3bn2z65wq0ovw" />
        <FAQ data-id="element-12" data-mp="3bnmedeuzkz68" />
        <FinalCTA data-id="element-13" data-mp="3bo4mp9uxb3ui" />
      </main>
      <Footer data-id="element-14" data-mp="3qb7jtffc3ahb" />
      <noscript data-id="element-15" data-mp="3qbpon0g2ax0u">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-16" data-mp="3qc96kh5pplev" />
      </noscript>
      <PurchaseNotifications data-id="element-17" data-mp="2xtbzrqcpeldw" />
    </div>;
}